module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-detail-bill"
  }, [_c('navbar', {
    attrs: {
      "title": "餐企报价单-明细编辑"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "common-scroll detail-scroll"
  }, [_c('p', {
    staticClass: "detail-bill-status"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.detailData.trans_bill_no) + "\n\t\t\t"), _c('span', {
    staticClass: "nav-btn",
    on: {
      "click": function($event) {
        return _vm.openBillInfo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/nav-btn.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "state-aqua-font"
  }, [_vm._v("已同意")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.billInfoShow),
      expression: "billInfoShow"
    }],
    staticClass: "bill-all-info"
  }, [_c('ul', {
    staticClass: "detail-bill-info-list"
  }, [_c('li', {
    staticClass: "detail-bill-fulllist"
  }, [_vm._v("报价企业：" + _vm._s(_vm.detailData.restaurant_name))]), _vm._v(" "), (_vm.detailData.endDate && _vm.detailData.endDate.length) ? _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("报价截止时间：" + _vm._s(_vm.detailData.endDate))]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "detail-bill-fulllist detail-bill-remark"
  }, [_vm._v("整单备注：" + _vm._s(_vm.detailData.remark))])])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-search-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWord),
      expression: "searchWord"
    }],
    staticClass: "detail-search-input",
    attrs: {
      "placeholder": "请输入要搜索的品项名称"
    },
    domProps: {
      "value": (_vm.searchWord)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWord = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-wrapper"
  }, [_c('h4', {
    staticClass: "detail-bill-address aqua-font"
  }, [_vm._m(0), _vm._v("\n\t\t\t\t明细条目(" + _vm._s(_vm.detailsFilter.length) + ")\n\t\t\t\t"), _c('a', {
    staticClass: "detail-bill-edit state-aqua-font",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('ul', {
    staticClass: "detail-bill-list"
  }, _vm._l((_vm.detailsFilter), function(detail) {
    return _c('li', {
      key: detail.goods_id
    }, [_c('ul', {
      staticClass: "detail-bill-sonlist"
    }, [_c('li', {
      staticClass: "detail-bill-fulllist detail-bill-list-title"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(detail.goods_name) + "(" + _vm._s(detail.goods_unit) + ")\n\t\t\t\t\t\t")]), _vm._v(" "), (_vm.isPesc) ? _c('li', [_vm._v("规格：" + _vm._s(detail.goods_spec))]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("税率\n\t\t\t\t\t\t\t"), (_vm.detailData.can_change_price) ? _c('span', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('span', {
      staticClass: "tax-operate tax-operate-reduce",
      on: {
        "click": function($event) {
          return _vm.reduce(detail)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_cess),
        expression: "detail.goods_cess"
      }],
      staticClass: "detail-bill-edit-taxinput",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (detail.goods_cess)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_cess", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "detail-bill-edit-percent"
    }), _vm._v(" "), _c('span', {
      staticClass: "tax-operate tax-operate-plus",
      on: {
        "click": function($event) {
          return _vm.plus(detail)
        }
      }
    })]) : _c('span', {
      staticStyle: {
        "position": "relative",
        "left": "-10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_cess),
        expression: "detail.goods_cess"
      }],
      staticClass: "detail-bill-edit-taxinput",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (detail.goods_cess)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_cess", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('li', [_vm._v("含税单价：\n\t\t\t\t\t\t\t"), (_vm.detailData.can_change_price) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_price_send),
        expression: "detail.goods_price_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (detail.goods_price_send)
      },
      on: {
        "blur": function($event) {
          return _vm.sendPriceCountFixed(detail)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_price_send", $event.target.value)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.goods_price_send),
        expression: "detail.goods_price_send"
      }],
      staticClass: "detail-bill-edit-input",
      attrs: {
        "type": "text",
        "readonly": "",
        "onfocus": "this.blur()"
      },
      domProps: {
        "value": (detail.goods_price_send)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(detail, "goods_price_send", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (detail.goods_price_recipient >= 0),
        expression: "detail.goods_price_recipient >= 0"
      }]
    }, [_vm._v("上次价格档案单价：\n\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("numFixed")(detail.goods_price_recipient, _vm.numScale)) + " 元")])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isZ5 && _vm.inquiryAmountFlag),
        expression: "isZ5 && inquiryAmountFlag"
      }]
    }, [_vm._v("询价数量：\n\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("numFixed")(detail.goods_num_sended, 4)))])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isZ5 && (detail.is_compare_price == 1)),
        expression: "isZ5 && (detail.is_compare_price == 1)"
      }]
    }, [_vm._v("参考含税单价：" + _vm._s(_vm._f("numFixed")(detail.reference_price, 4)))])])])
  }), 0)]), _vm._v(" "), (!_vm.detailsFilter.length) ? _c('div', {
    staticClass: "detail-bill-search-empty"
  }, [_c('div', {
    staticClass: "middle-empty"
  }), _vm._v(" "), _c('p', [_vm._v("未找到相关品项")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-footer"
  }, [_c('div', {
    staticClass: "detail-bill-agreen f-right"
  }, [_c('a', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('div', {
    staticClass: "detail-bill-return f-right"
  }, [_c('a', {
    on: {
      "click": _vm.billConfirm
    }
  }, [_vm._v("确认")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsTwoShow),
      expression: "tipsTwoShow"
    }],
    staticClass: "tips-mask-t",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideRuturnConfirm.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "tips-wrapper",
    class: {
      'tips-start': _vm.tipsTwoShow, 'tips-end': !_vm.tipsTwoShow
    }
  }, [_c('div', {
    staticClass: "tips-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.elseTipsFont))])]), _vm._v(" "), _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-two-btn tips-marbot red-font",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveReturn.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[0]))]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn tips-marbot",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.quitRuturn.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[1]))]), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideRuturnConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.elseBtnFont[2]))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsShowCompareReferencePrice),
      expression: "tipsShowCompareReferencePrice"
    }],
    staticClass: "tips-mask-t",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.confirmOverReferencePrice.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "tips-wrapper",
    class: {
      'tips-start': _vm.tipsShowCompareReferencePrice, 'tips-end': !_vm.tipsShowCompareReferencePrice
    }
  }, [_c('div', {
    staticClass: "tips-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.overReferencePriceMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-two-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.confirmOverReferencePrice.apply(null, arguments)
      }
    }
  }, [_vm._v("确认")])])])]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFontWaring": _vm.tipsWaring,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "list-btn fl"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/list_open.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0da39bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/QuotationDetailEdit.vue
// module id = 613
// module chunks = 1